<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-5">
              <b-row align-v="center" class="pb-5">
                <b-col class="text-center">
                  <img src="/static/img/logo.png" alt="" style="width: 10vw; height: auto"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p class="text-muted text-center">Sign In to your account</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form @submit="onSubmit">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <input type="email" class="form-control" placeholder="Email" v-model="user.email" required/>
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <input type="password" class="form-control" placeholder="Password" v-model="user.password"
                             required/>
                    </b-input-group>
                    <b-row>
                      <b-col class="text-right">
                        <b-button type="submit" variant="primary">Login</b-button>
                      </b-col>
                      <!--<b-col cols="6" class="text-right">-->
                      <!--<b-button variant="link" class="px-0">Forgot password?</b-button>-->
                      <!--</b-col>-->
                    </b-row>
                  </b-form>
                </b-col>
              </b-row>
            </b-card>
            <!--<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">-->
            <!--<b-card-body class="text-center">-->
            <!--<div>-->
            <!--<h2>Sign up</h2>-->
            <!--<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>-->
            <!--<b-button variant="primary" class="active mt-3">Register Now!</b-button>-->
            <!--</div>-->
            <!--</b-card-body>-->
            <!--</b-card>-->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      user: {
        email: '',
        password: ''
        // email: 'tech@threls.com',
        // password: 'password'
      }
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      this.$store.dispatch('user/login', {
        ...this.user
      })
    }
  },
  computed: {
    ...mapGetters('user', [
      'isUserLoggedIn'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Login.vue